/** Only browser links can be opened or embedded by game cards. */
export function safeGameUrl(value?: string): string {
  try {
    const url = new URL(value || '');
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}

export function gameEmbedUrl(value?: string): string {
  const safe = safeGameUrl(value);
  if (!safe) return '';
  const url = new URL(safe);
  const scratch = url.hostname === 'scratch.mit.edu' && url.pathname.match(/^\/projects\/(\d+)(?:\/|$)/);
  return scratch ? `https://scratch.mit.edu/projects/${scratch[1]}/embed` : safe;
}
